import { useCallback, useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { MoreIcon } from '../../../../../components/Icon';
import { BED_STATUS_CUBICLE_COLOR, E_ADMISSION_GRID_SIMENSIONS } from '../../../../../comm/constant';
import useCheckLogin from '../../../../../utils/useCheckLogin';
import LocCubicleDialog from '../../LocCubicleDialog';
import LandingUpdateCubicleDialog from './LandingUpdateCubicleDialog';

const useStyles = makeStyles(() => ({
  root: ({ cubicleData }) => ({
    backgroundColor: BED_STATUS_CUBICLE_COLOR[cubicleData?.color] ?? '#fff',
  }),
  name: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: '#7d86a9',
    fontSize: '1.25rem',
    width: '80%',
    textAlign: 'center',
  },
  moreBtn: {
    width: '2rem',
    height: '2rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '4px',
  },
  moreIcon: {
    fontSize: '1rem',
    color: '#7d86a9',
  },
}));

const EADNurseStation = ({
  style = {},
  cubicleData,
  id,
  handleUpdateCubicle = null,
  handleDeleteCubicle = null,
  handleCopyCubicle = null,
  editMode = false,
}) => {
  const classes = useStyles({ cubicleData });
  const checkLogin = useCheckLogin();
  const [editOpen, setEditOpen] = useState(false);

  const handleOpenMore = useCallback(() => {
    if (checkLogin()) {
      setEditOpen(true);
    }
  }, [checkLogin, cubicleData]);

  const renderEditPopup = () => {
    const params = {
      handleClose: () => setEditOpen(false),
      showPopup: editOpen,
      cubicleId: id,
      cubicleData: cubicleData,
      handleSubmit: handleUpdateCubicle,
    };

    if (editMode) {
      return (
        <LocCubicleDialog
          {...params}
          operation="edit"
          handleCopyCubicle={handleCopyCubicle}
          handleDeleteCubicle={handleDeleteCubicle}
        />
      );
    }

    return <LandingUpdateCubicleDialog {...params} />;
  };

  return (
    <>
      <Box
        className={classes.root}
        style={style}
        position="relative"
        display="inline-flex"
        minWidth={E_ADMISSION_GRID_SIMENSIONS?.width}
        minHeight={E_ADMISSION_GRID_SIMENSIONS?.height}
        border={cubicleData?.borderLine === 'show' ? 'solid 1px #AAAAAA' : 'unset'}
        borderRadius="8px"
        p="0.875rem 0.813rem 0.875rem 0.688rem"
      >
        <Box position="absolute" right="0.75rem">
          <ButtonBase className={classes.moreBtn} onClick={handleOpenMore}>
            <MoreIcon className={classes.moreIcon} />
          </ButtonBase>
        </Box>
        <div className={classes.name}>{cubicleData?.name}</div>
        {/* 撑开size */}
        <Box display="flex" flexDirection="column">
          <Box height="4.5rem" width="100%" />
          <Box
            display="grid"
            gridTemplateRows={`repeat(${cubicleData?.bedArrangement?.row}, 1fr)`}
            gridTemplateColumns={`repeat(${cubicleData?.bedArrangement?.column}, 1fr)`}
            gridGap="0.2rem"
          >
            {_.map(cubicleData?.beds, (item) => (
              <Box
                key={item.key}
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={E_ADMISSION_GRID_SIMENSIONS?.width}
                height={E_ADMISSION_GRID_SIMENSIONS?.height}
                pt="1.563rem"
              />
            ))}
          </Box>
        </Box>
      </Box>

      {editOpen && renderEditPopup()}
    </>
  );
};

export default EADNurseStation;
